(function( $ ) {

    $('#signupForm').submit(function(e){
        e.preventDefault();
        $("#register-error").html('');
        $("#register-success").addClass('d-none');
    });

    $('#signupForm').validate({
        rules: {
            firstname: {
                required: true,
                customText: true,
                maxlength: 100,
            },
            lastname: {
                required: true,
                customText: true,
                maxlength: 100,
            },
            email: {
                required: true,
                customEmail: true,
                maxlength: 100,
            },
            city: {
                //required: true,
            },
            country: {
                required: true,
            },
            birthday:{
                required: true,
                birthday : true,
            },
            password: {
                required: true,
                minlength: 8,
                passwordNumber: true,
                passwordLetter: true
            },
            confirm: {
                required: true,
                minlength: 8,
                equalTo: "#pwd",
                passwordNumber: true,
                passwordLetter: true
            }
        },
        messages: {
            password: {
                minlength: 'Password too short'
            },
            confirm: {
                minlength: 'Password too short'
            }
        },
        submitHandler: function (form) { 

            var firstname = $(form).find('input[name="firstname"]').val();
            var lastname = $(form).find('input[name="lastname"]').val();
            var email = $(form).find('input[name="email"]').val();
            var city =$(form).find('input[name="city"]').val();
            var country = $(form).find('select[name="country"]').val();
            var birthday = $(form).find('input[name="birthday"]').val();
            var gender = $(form).find('input[name="gender"]:checked').val();
            var pwd = $(form).find('input[name="password"]').val();
            var cpwd = $(form).find('input[name="confirm"]').val();
            var csrfToken = $(form).find('input[name="csrfToken"]').val();

            $.ajax({
                type: "POST",
                url: "includes/register-exec.php",
                data: {
                    firstname: firstname,
                    lastname: lastname,
                    email: email,
                    city: city,
                    country: country,
                    birthday: birthday,
                    gender: gender,
                    pwd: pwd,
                    cpwd: cpwd,
                    token: csrfToken
                },
                dataType: 'json',
                beforeSend: function() {
                    $('#content-preloader').show();
                }, 
                complete: function() {
                    $('#content-preloader').fadeOut(500);
                },
                success: function (data) {
                    //console.log(data);        
                    var msg = JSON.parse(JSON.stringify(data));
                    if (msg.success == true) {
                        $("#register-success").removeClass('d-none');
                        $(".left-column").animate({ scrollTop: 0 }, "slow");
                    } else {
                        $("#register-error").html('<div class="alert alert-danger" role="alert">'+msg.reason+'</div>');
                        $(".left-column").animate({ scrollTop: 0 }, "slow");
                    }
                },
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    console.log("Status: " + textStatus);
                    console.log("Error: " + errorThrown);
                    console.log(XMLHttpRequest.responseText);
                }
            });
            return false;
        }
    });

}(jQuery));